import React, { useState, useEffect } from 'react';
import { Card, Button, Spinner } from 'react-bootstrap';
import { LuMailCheck, LuRefreshCw, LuArrowRight } from "react-icons/lu";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getProfile } from '../../redux/reducers/authSlice';
import { toast } from 'react-toastify';

const VerifyNotice = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userDetail, loading } = useSelector((state) => state.auth);
    const [checking, setChecking] = useState(false);

    // If they are already verified, push them forward immediately
    useEffect(() => {
        if (userDetail?.isVerified) {
            navigate("/onboarding/setup-business");
        }
    }, [userDetail, navigate]);

    const checkVerificationStatus = async () => {
        setChecking(true);
        // This thunk calls our /profile API which returns fresh isVerified status
        const result = await dispatch(getProfile());

        if (result.payload?.isVerified) {
            toast.success("Email verified! Let's set up your business.");
            navigate("/onboarding/setup-business");
        } else {
            toast.warning("Email not verified yet. Please check your inbox (and spam folder).");
        }
        setChecking(false);
    };

    return (
        <div className="auth-wrapper d-flex align-items-center justify-content-center bg-light px-3" style={{ minHeight: '100vh' }}>
            <Card className="auth-card border-0 shadow-lg rounded-4 p-4 text-center" style={{ maxWidth: '450px', width: '100%' }}>
                <div className="mb-4">
                    <div className="bg-primary-subtle rounded-circle d-inline-flex align-items-center justify-content-center text-primary" style={{ width: '80px', height: '80px' }}>
                        <LuMailCheck size={40} />
                    </div>
                </div>

                <h3 className="fw-bold text-dark">Check Your Email</h3>
                <p className="text-muted">
                    We've sent a verification link to:<br />
                    <strong className="text-dark">{userDetail?.email}</strong>
                </p>

                <div className="bg-light p-3 rounded-3 mb-4 small text-start border">
                    <strong>Next Step:</strong> Click the link in the email to unlock your account setup.
                </div>

                <Button
                    variant="brand"
                    className="w-100 py-2 fw-bold mb-3 d-flex align-items-center justify-content-center gap-2"
                    onClick={checkVerificationStatus}
                    disabled={checking}
                >
                    {checking ? <Spinner animation="border" size="sm" /> : "I'VE VERIFIED MY EMAIL"}
                    <LuArrowRight size={18} />
                </Button>

                <Button
                    variant="link"
                    className="text-muted text-decoration-none small d-flex align-items-center justify-content-center gap-2"
                >
                    <LuRefreshCw size={14} /> Resend Email
                </Button>
            </Card>
        </div>
    );
};

export default VerifyNotice;
